export function buildPonKeyFromIds(
  uniqueId?: string | null,
  oltIfIndex?: number | null,
  nr?: number | null,
): string | null {
  const cleanUnique = uniqueId?.trim();
  if (cleanUnique) {
    return cleanUnique;
  }
  if (oltIfIndex != null && nr != null) {
    return `${oltIfIndex}:${nr}`;
  }
  if (oltIfIndex != null) {
    return String(oltIfIndex);
  }
  if (nr != null) {
    return String(nr);
  }
  return null;
}

export function buildOnuRowKey(
  item: {
    id?: number | null;
    sn?: string | null;
    unique_id?: string | null;
    mac?: string | null;
    nr?: number | null;
  },
  fallbackKey?: string | null,
  index?: number,
): string {
  if (item.id != null) {
    return `id:${item.id}`;
  }
  const preferred =
    item.sn?.trim()
    || item.unique_id?.trim()
    || item.mac?.trim()
    || (item.nr != null ? `nr:${item.nr}` : null)
    || fallbackKey;
  if (preferred) {
    return preferred;
  }
  return `onu-${index ?? Date.now()}`;
}

